import { render, staticRenderFns } from "./UploadableAvatar.vue?vue&type=template&id=f7067f26&scoped=true&lang=pug"
import script from "./UploadableAvatar.vue?vue&type=script&lang=js"
export * from "./UploadableAvatar.vue?vue&type=script&lang=js"
import style0 from "./UploadableAvatar.vue?vue&type=style&index=0&id=f7067f26&prod&lang=scss&scoped=true"
import style1 from "./UploadableAvatar.vue?vue&type=style&index=1&id=f7067f26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7067f26",
  null
  
)

export default component.exports